import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { sizes } from "../../../enums";
import { toUIProps } from "../../../util";
import { Image as UIImage } from 'semantic-ui-react';
import { whitelistStyles } from "../hoc";
var UNSUPPORTED_PROPS = ['as', 'className'];
var ImageGroup = createComponent({
  displayName: 'ImageGroup',
  propTypes: {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
    size: PropTypes.oneOfType([PropTypes.oneOf(sizes.ALL), PropTypes.shape({
      width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })]).isRequired
  },
  render: function render(props) {
    var _context;

    var UIProps = toUIProps({
      props: props,
      UNSUPPORTED_PROPS: UNSUPPORTED_PROPS
    });
    delete UIProps.children;
    delete UIProps.size;

    var children = _mapInstanceProperty(_context = React.Children).call(_context, props.children, function (image) {
      return image.props.size === undefined ? /*#__PURE__*/React.cloneElement(image, {
        size: props.size
      }) : image;
    });

    return /*#__PURE__*/React.createElement(UIImage.Group, UIProps, children);
  }
});
export default whitelistStyles()(ImageGroup);
//# sourceMappingURL=image-group.js.map